module.exports = __webpack_public_path__ + "img/slogon.f3f1bab9.png";